var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Part',{attrs:{"section":"understand","chapters":_vm.chapters}})
}
var staticRenderFns = []

export { render, staticRenderFns }